import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const DeliveryUniform = () => {
  const [filters, setFilters] = useState({
    school_id: "",
    class_id: "",
  });

  const [loading, setLoading] = useState(false);
  const today = new Date().toISOString().split("T")[0]; // "YY
  const [schoolList, setSchoolList] = useState([]);
  const [sectionlList, setSectionList] = useState([]);

  const [classList, setClassList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [deliveryListItemWise, setDeliveryListItemWise] = useState([]);

  const allSelected =
    deliveryList.length > 0 && selectedIds.length === deliveryList.length;

  const fetchDeliveredData = async () => {
const token = localStorage.getItem("token");

    if (!filters.school_id) return;

    try {
      setLoading(true);

      const response = await axios.post(
        `${BASE_URL}/getDataForDelivery`,
        {
          school_id: filters.school_id,
          class_id: filters.class_id || "",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.data.status === true) {
        setDeliveryList(response.data.data.student_wise || []);
        setDeliveryListItemWise(response.data.data.item_size_summary || []);
      } else {
        setDeliveryList([]);
        setDeliveryListItemWise([]);
      }
    } catch (err) {
      handle401(err);
    } finally {
      setLoading(false);
    }
  };

  const loadSchools = async () => {
    try {
  const token = localStorage.getItem("token");
      const municipality_id = localStorage.getItem("municipality_id");

      let payload = {};

      payload = {
        municipality_id: municipality_id,
      };

      const res = await axios.post(`${BASE_URL}/schoolList`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSchoolList(res.data.data || []);
    } catch (err) {
      handle401(err);
    }
  };

  const loadClasses = async () => {
    try {
  const token = localStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/classList`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClassList(res.data.data.class_list || []);
    } catch (err) {
      handle401(err);
    }
  };

  const fetchSectionList = async() =>{
      try{
      const token = localStorage.getItem("token");
          const response = await axios.get(`${BASE_URL}/sectionList`,

          { headers: { Authorization: `Bearer ${token}` } }
      )

      if(response.data.status === true){
          setSectionList(response.data.data.sectionList || []);
      }
      else{
          console.log("error sectionlist");
      }

      }catch(err){
         console.error("Student count error", err);
        if (handle401(err)) return;
      }
    }

//   const handleDelivery = async () => {
//     if (selectedIds.length === 0) {
//       Swal.fire("Warning", "Please select at least one student", "warning");
//       return;
//     }

// const token = localStorage.getItem("token");

//     const payload = deliveryList
//       .filter((student) => selectedIds.includes(student.student_id))
//       .map((student) => ({
//         student_id: student.student_id,
//         measurement_ids:
//           student.items?.map((item) => item.measurement_id) || [],
//       }));

//     try {
//       const response = await axios.post(
//         `${BASE_URL}/doDelivery`,
//         { deliveries: payload },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );

//       if (response.data.status) {
//         Swal.fire("Success", `${response.data.message}`, "success");
//         setSelectedIds([]);
//         fetchDeliveredData();
//       } else {
//         Swal.fire("Error", response.data.message, "error");
//       }
//     } catch (error) {
//       handle401(error);
//     }
//   };

// const handleDelivery = async () => {
//   if (selectedIds.length === 0) {
//     Swal.fire("Warning", "Please select at least one student", "warning");
//     return;
//   }

//   const confirmResult = await Swal.fire({
//     title: "Are you sure?",
//     text: "Do you want to proceed with delivery for selected students?",
//     icon: "question",
//     showCancelButton: true,
//     confirmButtonText: "Yes, Deliver",
//     cancelButtonText: "Cancel",
//     confirmButtonColor: "#3085d6",
//     cancelButtonColor: "#d33",
//   });

//   if (!confirmResult.isConfirmed) return;

//   const token = localStorage.getItem("token");

//   const payload = deliveryList
//     .filter((student) => selectedIds.includes(student.student_id))
//     .map((student) => ({
//       student_id: student.student_id,
//       measurement_ids:
//         student.items?.map((item) => item.measurement_id) || [],
//     }));

//   try {
//     const response = await axios.post(
//       `${BASE_URL}/doDelivery`,
//       { deliveries: payload },
//       {
//         headers: { Authorization: `Bearer ${token}` },
//       }
//     );

//     if (response.data.status) {
//       Swal.fire("Success", response.data.message, "success");
//       setSelectedIds([]);
//       fetchDeliveredData();
//     } else {
//       Swal.fire("Alert", response.data.message, "error");
//     }
//   } catch (error) {
//     handle401(error);
//   }
// };


const handleDelivery = async () => {
  if (selectedIds.length === 0) {
    Swal.fire("Warning", "Please select at least one student", "warning");
    return;
  }

  const confirmResult = await Swal.fire({
    title: "Are you sure?",
    text: "Do you want to proceed with delivery for selected students?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Deliver",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
  });

  if (!confirmResult.isConfirmed) return;

  const token = localStorage.getItem("token");

  const payload = deliveryList
    .filter((student) => selectedIds.includes(student.student_id))
    .map((student) => ({
      student_id: student.student_id,
      measurement_ids:
        student.items?.map((item) => item.measurement_id) || [],
    }));

  try {
    setLoading(true);

    const response = await axios.post(
      `${BASE_URL}/doDelivery`,
      { deliveries: payload },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (response.data.status) {
      Swal.fire("Success", response.data.message, "success");
      setSelectedIds([]);
      fetchDeliveredData();
    } else {
      Swal.fire("Alert", response.data.message, "error");
    }
  } catch (error) {
    handle401(error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    loadSchools();
    loadClasses();
    fetchSectionList();
  }, []);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* ================= FILTER CARD ================= */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter"></i> Uniform Delivery
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-black">
                  School <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={filters.school_id}
                  onChange={(e) =>
                    setFilters({ ...filters, school_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select School</option>

                  {schoolList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-black">
                  Class (Optional)
                </Form.Label>
                <Form.Select
                  value={filters.class_id}
                  onChange={(e) =>
                    setFilters({ ...filters, class_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select Class</option>

                  {classList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* <Col md={3}>
                              <Form.Group className="mb-3">
                                <Form.Label className="fw-semibold text-black">
                                  Section <span className="text-danger">*</span>
                                </Form.Label>

                                 <Form.Select
style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                                >
                                  <option value="">Select Section</option>

                                  {sectionlList.map((sec) => (
                                    <option key={sec.id} value={sec.id}>
                                      {sec.section_name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col> */}

            <Row>
              <Col md={2} className="mt-3">
                <Button
                  className="w-100 fw-semibold text-white"
                  style={{ background: "#1565C1", borderRadius: "10px" }}
                  onClick={() => {
                    if (!filters.school_id) {
                      Swal.fire(
                        "Alert",
                        "Please select atleast one School",
                        "warning",
                      );
                      return;
                    }
                    fetchDeliveredData();
                  }}
                >
                  <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                </Button>
              </Col>

              {/* Reset Button */}
              <Col md={2} className="mt-3">
                <Button
                  className="w-100 fw-semibold text-white"
                  style={{ background: "#E53935", borderRadius: "10px" }}
                  onClick={() => {
                    setFilters({
                      school_id: "",
                      class_id: "",
                    });

                    setDeliveryList([]);
                    setDeliveryListItemWise([]);
                    setSelectedIds([]);
                  }}
                >
                  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                </Button>
              </Col>
            </Row>
          </Row>
        </Card.Body>
      </Card>

      <div className="mt-3">


        <Row>
          {deliveryListItemWise.map((item, index) => (
            <Col md={2} key={index} className="mb-3">
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2"
                style={{
                  background: "linear-gradient(135deg, #42A5F5, #1E88E5)",
                  borderRadius: "50px",
                  boxShadow: "0 4px 12px rgba(30,136,229,0.35)",
                  color: "#fff",
                }}
              >
                <div style={{ lineHeight: "1.2" }}>
                  <div style={{ fontSize: "16px", fontWeight: "600" }}>
                    {item.item_name}
                  </div>
                  <div style={{ fontSize: "16px", opacity: 0.9 }}>
                    Size: {item.size}
                  </div>
                </div>

                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {item.total_quantity}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>


            <Col md={6}>
              <Button
                variant="success"
                style={{ width: "270px" }}
                disabled={selectedIds.length === 0}
                className="text-white mb-3"
                onClick={handleDelivery}
              >
                <i className="fa-solid fa-truck me-2"></i>
               Do Delivery
              </Button>
            </Col>


      {/* ================= TABLE ================= */}




      {loading && (
        <div className="loader-wrapper">
          <div className="blue-spinner"></div>

          <div className="loading-line">
            <div className="loading-progress"></div>
          </div>

          <p className="loading-text">Loading, please wait...</p>
        </div>
      )}
      {!loading && (
        <Card
          className="mb-4 border-0"
          style={{
            background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
            boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          }}
        >
          <Table bordered hover responsive striped>
            <thead>
              <tr>
                <th
                  style={{
                    width: "130px",
                    minWidth: "50px",
                    maxWidth: "130px",
                    padding: "4px",
                    backgroundColor: "#edf7fe",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  <Form.Check
                    type="checkbox"
                    //   label="All"
                    checked={allSelected}
                    onChange={(e) => {
                      if (e.target.checked) {
                        const allIds = deliveryList.map((row) => row.student_id);
                        setSelectedIds(allIds);
                      } else {
                        setSelectedIds([]);
                      }
                    }}
                    style={{ margin: 0 }}
                  />
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  SL
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  School
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Class
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Section
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Roll no
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Gender
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Items
                </th>
              </tr>
            </thead>
            <tbody>
              {!loading && deliveryList.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No records found
                  </td>
                </tr>
              )}

              {deliveryList.map((row, index) => (
                <tr key={row.student_id}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={selectedIds.includes(row.student_id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedIds((prev) => [...prev, row.student_id]);
                        } else {
                          setSelectedIds((prev) =>
                            prev.filter((id) => id !== row.student_id),
                          );
                        }
                      }}
                    />
                  </td>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{row.school_name}</td>
                  <td className="text-center">{row.class_name}</td>
                  <td className="text-center">{row.section_name}</td>
                  <td className="text-center">{row.roll_no}</td>
                  <td className="text-center">{row.gender}</td>
                  <td className="text-center">
                    <div className="d-flex flex-wrap justify-content-center gap-2">
                      {row.items?.map((item, i) => (
                        <span
                          key={i}
                          style={{
                            background:
                              "linear-gradient(135deg, #42A5F5, #1E88E5)",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.item_name} ({item.size}) × {item.quantity}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>


        </Card>
      )}
    </div>
  );
};

export default DeliveryUniform;
